import styled from 'styled-components';
import { RichText } from '@atlassiansox/bxp-content-framework';
export const SelectText = styled(RichText) `
  text-align: center;
`;
export const TeamsContainer = styled.div `
  align-items: center;
  display: flex;
  flex-flow: wrap;
  gap: 1rem;
  margin: 1rem;
`;
//# sourceMappingURL=SelectTextMessage.styles.js.map